import { FormEvent, useState } from "react";
import { useEmailService } from "../../libs/email/email-check.hook";
import { ErrorCodes } from "../../libs/error-handling/errors";
import { RegistrationSteps } from "../../libs/registration/registration-steps";
import { useRegistration } from "../../libs/registration/registration.hook";
import { AppForm } from "../form/styles/app-form";
import { BackButton } from "../form/styles/back-button";
import { CtaButton } from "../form/styles/cta-button";
import { SingleInput } from "../form/styles/single-input";
import { LoadingComp } from "../loading/loading.comp";

export const EmailComp = (props: {
  setStep: (step: RegistrationSteps) => void;
}) => {
  const [email, setEmail] = useState("");
  const { fetching, checkEmail } = useEmailService();
  const { setRegistrationInfo } = useRegistration();

  const isEmail = email.includes(".") && email.includes("@");

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();

    if (isEmail) {
      const resp = await checkEmail(email);
      setRegistrationInfo({ email });

      if (resp.errorCode === ErrorCodes.ClientNotFound) {
        props.setStep(RegistrationSteps.ContactInfo);
      } else {
        props.setStep(RegistrationSteps.Pin);
      }
    }
  };

  const onBack = (event: FormEvent) => {
    event.preventDefault();
    props.setStep(RegistrationSteps.Info);
  };

  return (
    <AppForm onSubmit={onSubmit}>
      <SingleInput
        onChange={(event: any) => setEmail(event.target.value)}
        value={email}
        placeholder="Your email"
      />

      <div>
        <BackButton onClick={onBack}>Back</BackButton>
        <CtaButton disabled={!isEmail}>Next</CtaButton>
      </div>
      {fetching && <LoadingComp />}
    </AppForm>
  );
};
